jQuery(function($) {
	
   /* Fix any inputs that are missing bootstrap support */
	$('input[type="text"]:not(.ekmps-search-field):not(.form-control)').addClass('form-control');
	$('input[type="submit"]:not(.ekmps-search-button):not(.btn)').addClass('btn btn-secondary');
	
	
	
	$('.carousel-sync').on('slide.bs.carousel', function(ev) {
		// get the direction, based on the event which occurs
		var dir = ev.direction == 'right' ? 'prev' : 'next';
		// get synchronized non-sliding carousels, and make'em sliding
		$('.carousel-sync').not('.sliding').addClass('sliding').carousel(dir);
	});
	$('.carousel-sync').on('slid.bs.carousel', function(ev) {
		// remove .sliding class, to allow the next move
		$('.carousel-sync').removeClass('sliding');
	});
	
	
	
});

/**
 * -------------------------------------
 * Mobile Menu Methods
 * -------------------------------------
 */

function openMenu(selector) {
   document.body.classList.add("mobile-noscroll");
   var menu = document.getElementById(selector);
   menu.style.height = "120%";
   menu.classList.add("active");
}

function closeMenu(selector) {
   document.body.classList.remove("mobile-noscroll");
   var menu = document.getElementById(selector);
   menu.style.height = "0%";
   menu.classList.remove("active");
}